import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { get } from "../lib/api";
import useStoreCategories from "../lib/useStoreCategories";
import HomeCategoryPicker from "./HomeCategoryPicker";
export default function CategoryVisitNotice({ vendor }) {
  const { user } = useAuth();
  const { categories } = useStoreCategories();
  const [currentCategory, setCurrentCategory] = useState(null);
  const [exploringCategory, setExploringCategory] = useState('');
  useEffect(() => {
    let cancelled = false;
    if (user?.role !== "CUSTOMER") return;
    get("/customers/me")
      .then((r) => {
        if (!cancelled)
          setCurrentCategory(r.customer?.currentProductCategory || "");
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [user?.id, user?.role]);
  if (
    user?.role !== "CUSTOMER" ||
    !vendor?.vendorCategory ||
    currentCategory === null ||
    currentCategory === vendor.vendorCategory
  )
    return null;
  const label =
    categories.find((item) => item.value === vendor.vendorCategory)?.label ||
    vendor.vendorCategory;
  return (
    <aside
      role="status"
      className="mx-auto w-full max-w-7xl rounded-xl border border-blue-200 bg-blue-50 p-4 text-sm text-blue-950"
    >
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <p>
          You are viewing <strong>{label}</strong>. Want to view more products
          like this?
        </p>
        <HomeCategoryPicker
          user={user}
          currentCategory={currentCategory}
          onSelecting={setExploringCategory}
          onSelected={(category) => setCurrentCategory(category.value)}
          onFailed={() => setExploringCategory('')}
        />
        {exploringCategory && <span role="status">Exploring {exploringCategory} at bigcircle.ph</span>}
      </div>
    </aside>
  );
}
